import { Injectable } from '@angular/core';
import { ConfigService, urls } from './config.service';
import { HttpClient } from '@angular/common/http';
import { HTTP_REQUESTS_TIMEOUT } from '../constant';
import { timeout } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminService {
  constructor(
    private readonly configService: ConfigService,
    private httpClient: HttpClient
  ) {}

  getDeliveryMethods() {
    const url = this.configService.getUrl('admin.deliveryMethods');
    return this.httpClient
      .get(url, {
        withCredentials: true,
      })
      .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  addDeliveryMethod(request: any) {
    const url = this.configService.getUrl('admin.addDeliveryMethod');
    return this.httpClient
      .post(url, request, {
        withCredentials: true,
      })
      .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  updateDeliveryMethod(request: any, id: string) {
    const url = this.configService
      .getUrl('admin.updateDeliveryMethod')
      ?.replace(':id', id);
    return this.httpClient
      .put(url, request, {
        withCredentials: true,
      })
      .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  deleteDeliveryMethod(id: string) {
    const url = this.configService
      .getUrl('admin.deleteDeliveryMethod')
      ?.replace(':id', id);
    return this.httpClient
      .delete(url, {
        withCredentials: true,
      })
      .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  public getAdminTasks() {
    const url = urls.admin.getAllTasks;
    return this.httpClient.get(url, {withCredentials: true}).pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  public addNewTask(task: any) {
    const url = urls.admin.addNewTask;
    return this.httpClient.post(url, task, {withCredentials: true}).pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  public updateTask(task: any) {
    const url = urls.admin.updateTask.replace(":id", task?.id);
    return this.httpClient.post(url, task, {withCredentials: true}).pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  public deleteTask(taskId: any) {
    const url = urls.admin.deleteTask.replace(":id", taskId);
    return this.httpClient.delete(url, {withCredentials: true}).pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  public editUserScore(userId: string, request: any) {
    const url = urls.admin.editUserScore.replace(":id", userId);
    return this.httpClient.put(url, request, {withCredentials: true}).pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }



  // getUserScores(id: string) {
  //   const url = this.configService.
  // }
}
